module.exports = __webpack_public_path__ + "media/images/home-page/Testimonial-BG@2x-fd38f0216744dccd2f9085ee1fc26ba8.png";